import { Component } from '@angular/core';

@Component({
  selector: 'demo-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
  standalone: false,
})
export class DemoButtonsComponent {}
